import { useToggle } from '@sdk/common/hooks/useToggle';

export const useBulkMessageMode = () => {
  const { isOn: bulkMessageEnabled, toggle: onBulkMessageToggle } = useToggle(false);

  return {
    bulkMessageEnabled,
    onBulkMessageToggle,
  };
};
